var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfessionOtherCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "47px",
    viewBox: "0 0 40 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-467.000000, -904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "professional",
    transform: "translate(0.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(37.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marker/ico_freefloater_inactive"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.75,40.2139037 L20,47 L13.25,40.2139037 L0,40.2139037 L0,0 L40,0 L40,40.2139037 L26.75,40.2139037 Z",
    id: "Combined-Shape",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    strokeWidth: 1,
    transform: "translate(5.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,7 L27,7",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.880095)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    strokeWidth: 1.5,
    points: "24.75 16.3699048 24.75 19.3699048 29.25 19.3699048 29.25 7.61990476 26 5.61990476 23 0.869904762 7 0.869904762 4 5.61990476 0.75 7.61990476 0.75 19.3699048 6.25 19.3699048 6.25 16.3699048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,6.11990476 L30,4.11990476",
    id: "Stroke-4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,6.11990476 L0,4.11990476",
    id: "Stroke-6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,16.3699048 L3,16.3699048",
    id: "Stroke-8",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFFFFF",
    points: "23.5 10.5 24 12.5 29 10.5 29 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13-Copy",
    fill: "#FFFFFF",
    transform: "translate(3.750000, 10.250000) scale(-1, 1) translate(-3.750000, -10.250000) ",
    points: "1 10.5 1.5 12.5 6.5 10.5 6.5 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#FFFFFF",
    points: "21 11 9 11 8.5 13 21.5 13"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#191919",
    x: 2,
    y: 3,
    width: 35,
    height: 33
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_business_bag",
    transform: "translate(7.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,13 L14,15 L10,15 L10,13 L4,13 L4,19 L20,19 L20,13 L14,13 Z M4,11 L20,11 L20,8 L4,8 L4,11 Z M8,6 L8,3 L16,3 L16,6 L22,6 L22,21 L2,21 L2,6 L8,6 Z M10,6 L14,6 L14,5 L10,5 L10,6 Z",
    id: "shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionOtherCompany);
export default __webpack_public_path__ + "static/media/profession_otherCompany.e84346718367d19b7db03b9c0cf4f4bf.svg";
export { ForwardRef as ReactComponent };